import { StandingsItem } from '../../../core/standings/types';
import { Card, TableCell } from '@mui/material';
import React from 'react';
import ProblemCell from './ProblemCell';
import { problemHeaderStyle, solveCountStyle, statusCardStyle } from './styles';
import Tooltip from '@mui/material/Tooltip';
import { Link, useParams } from 'react-router-dom';
import { keyframes } from '@mui/system';

interface Props {
	offset: number;
	index: number | null | undefined;
	data: StandingsItem;
}

// Flashing animation for banned users
const flashAnimation = keyframes`
	0%, 100% { background-color: rgba(255, 0, 0, 0.15); }
	50% { background-color: rgba(255, 140, 0, 0.25); }
`;

function StandingsRow({ offset, index, data }: Props) {
	const { contestSlug } = useParams();
	const isBanned = data?.is_banned === true;

	const cellSx = isBanned
		? {
				animation: `${flashAnimation} 2s infinite ease-in-out`,
				color: 'rgba(0, 0, 0, 0.4)',
				textDecoration: 'line-through',
		  }
		: {};

	return (
		<>
			<TableCell align={'center'} sx={cellSx}>
				<strong style={{ fontSize: '16px', color: 'rgb(0,70,101)' }}>{offset + (index || 0) + 1}</strong>
			</TableCell>
			<TableCell sx={cellSx}>
				<Tooltip title={data?.username}>
					<strong style={{ fontSize: '16px', color: 'rgb(0,73,110)' }}>{data?.fullname}</strong>
				</Tooltip>
				<div style={{ fontSize: '12px', color: 'rgb(110,110,110)' }}>{data?.institution?.toUpperCase()}</div>
			</TableCell>
			<TableCell align={'center'} style={problemHeaderStyle} sx={cellSx}>
				<Link
					to={`/contests/${contestSlug}/submissions?submitted_by=${data.username}`}
					style={{ textDecoration: 'none' }}
				>
					<Card
						sx={{
							...statusCardStyle,
							...(isBanned && { opacity: 0.4, filter: 'grayscale(70%)' }),
						}}
					>
						<div
							style={solveCountStyle}
							onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#6bbef0')}
							onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#419ad8')}
						>
							{data?.problem_total_points}
						</div>
						<div>({data?.total_fine})</div>
					</Card>
				</Link>
			</TableCell>
			{data?.problem_list.map((problemStatus, index) => (
				<TableCell align={'center'} key={index} sx={cellSx}>
					<ProblemCell problem={problemStatus} submittedBy={data.username} />
				</TableCell>
			))}
		</>
	);
}

export default StandingsRow;
